module.exports = __webpack_public_path__ + "img/logo.04d8cf7d.png";